import { render } from "./Person.vue?vue&type=template&id=63324f74&scoped=true"
import script from "./Person.vue?vue&type=script&lang=js"
export * from "./Person.vue?vue&type=script&lang=js"

import "./Person.vue?vue&type=style&index=0&id=63324f74&scoped=true&lang=css"

import exportComponent from "/home/ola/DevelopmentProjects/testdatano/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63324f74"]])

export default __exports__